module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"download":"Herunterladen","souvenirPhotos":"Erinnerungsfotos"},"en":{"download":"Download","souvenirPhotos":"Souvenir photos"}}')
  delete Component.options._Ctor
}
